<vi-checkbox-with-label [checked]="consent"
  [ariaLabel]="inputLabel"
  [label]="label"
  [disabled]="disabled"
  [labelSize]="'12-16'"
  dataTestId="consent-checkbox"
  (checkedChange)="toggle($event)">
</vi-checkbox-with-label>